import React from "react";
import { RedBorderSpan, GreenBorderSpan, YellowBorderSpan } from "../styled_components/divs";

const availIcon = (props) => {
  if (props.Value === "available") {
    return (
      <>
        <a
          href="#"
          key={"icon_a_resource_button_avail_" + props.Resource.id}
          onClick={() => {
            props.setInitialized(false);
            window.location.replace("/reservations/reservationsList?resource_id=" + props.Resource);
          }}
        >
          <GreenBorderSpan title={props.Title}>
            <i
              className="fi fi-torso torso"
              key={"icon_i_resource_button_avail_" + props.Resource.id}
            />
          </GreenBorderSpan>
        </a>
      </>
    );
  } else if (props.Value === "pending") {
    return (
      <>
        <a
          href="#"
          key={"icon2_a_resource_button_pend_" + props.Resource.id}
          onClick={() => {
            props.setInitialized(false);
            window.location.replace(
              "/reservations/reservationsList?reservation_id=" + props.Reservation,
            );
          }}
        >
          <YellowBorderSpan title={props.Title}>
            <i
              className="fi fi-torso torso"
              key={"icon2_i_resource_button_avail_" + props.Resource.id}
            />
          </YellowBorderSpan>
        </a>
      </>
    );
  } else {
    return (
      <>
        <a
          href="#"
          key={"icon2_a_resource_button_notavail_" + props.Resource.id}
          onClick={() => {
            props.setInitialized(false);
            window.location.replace(
              props.Value === "inprogress"
                ? "/reservations/reservationsList?reservation_id=" + props.Reservation
                : "/reservations/reservationsList?resource_id=" + props.Resource,
            );
          }}
        >
          <RedBorderSpan title={props.Title}>
            <i
              className="fi fi-torso torso"
              key={"icon2_i_resource_button_avail_" + props.Resource.id}
            />
          </RedBorderSpan>
        </a>
      </>
    );
  }
};

export default availIcon;
